var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarOnSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3567 32.3504L56.5 32.2045V32V27V26.5H56H47.5C47.5 21.5294 51.5294 17.5 56.5 17.5C61.4706 17.5 65.5 21.5294 65.5 26.5C65.5 31.4706 61.4706 35.5 56.5 35.5C55.5216 35.5 54.5804 35.3441 53.6995 35.0559L56.3567 32.3504ZM52.6902 34.6564C49.9105 33.3557 47.9059 30.6763 47.5549 27.5H55.5V31.7955L52.6902 34.6564Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H56V32L52.1933 35.8067L37.5 50.5L22.8067 35.8067L19 32V27Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 50.5V66M37.5 50.5L22.8067 35.8067M37.5 50.5L52.1933 35.8067M50.5 66H24M22.8067 35.8067L19 32V27H56V32L52.1933 35.8067M22.8067 35.8067H52.1933",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 36H52L37.5 50.5L23 36Z",
    fill: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarOnSite);
export default __webpack_public_path__ + "static/media/Bar_on_Site.18e045935fa310993659e8c4859e8b24.svg";
export { ForwardRef as ReactComponent };